module.exports = __webpack_public_path__ + "71572e50c84acdaf784c602ab9941c92.png";